import React, { forwardRef } from 'react';
import { TextareaAutosize, Box, FormHelperText, useMediaQuery } from '@mui/material';
import theme from '../../theme';

const CustomTextareaAutosize = forwardRef(
  (
    {
      value,
      onChange,
      onFocus,
      onBlur,
      minRows = 3,
      maxLength = 5000,
      placeholder = '내용을 입력해 주세요.',
      error = false,
      helperText,
      disabled = false,
      sx = {},
      ...restProps
    },
    ref,
  ) => {
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    // minRows가 객체인 경우 반응형 처리
    const resolvedMinRows =
      typeof minRows === 'object' ? (isMdUp ? (minRows.md ?? minRows.xs) : minRows.xs) : minRows;
    const handleChange = (e) => {
      if (maxLength && e.target.value.length > maxLength) {
        return;
      }
      if (onChange) {
        onChange(e);
      }
    };

    const handleFocus = (e) => {
      if (!disabled && !error) {
        e.target.style.borderColor = theme.palette.black[9];
        e.target.style.borderWidth = '2px';
      }
      if (onFocus) {
        onFocus(e);
      }
    };

    const handleBlur = (e) => {
      if (!disabled && !error) {
        e.target.style.borderColor = theme.palette.grey.line;
        e.target.style.borderWidth = '1px';
      }
      if (onBlur) {
        onBlur(e);
      }
    };

    const baseStyle = {
      width: '100%',
      resize: 'vertical',
      padding: '16px 12px',
      fontSize: '14px',
      border: `1px solid ${error ? theme.palette.red : theme.palette.grey.line}`,
      borderRadius: '4px',
      fontFamily: 'inherit',
      lineHeight: 1.5,
      outline: 'none',
      color: error ? theme.palette.red : 'var(--pp-text-primary)',
      ...sx,
    };

    return (
      <Box
        sx={{
          width: '100%',
          '& textarea::placeholder': {
            color: error ? 'transparent' : theme.palette.black[1],
            opacity: 1,
            fontSize: '14px',
          },
        }}
      >
        <TextareaAutosize
          ref={ref}
          minRows={resolvedMinRows}
          variant="outlined"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          maxLength={maxLength}
          style={baseStyle}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...restProps}
        />
        {helperText && (
          <FormHelperText
            error={error}
            sx={{
              textAlign: 'left',
              margin: '4px 0 0 0',
              fontSize: '12px',
              color: error ? theme.palette.red : theme.palette.black[1],
            }}
          >
            {helperText}
          </FormHelperText>
        )}
      </Box>
    );
  },
);

export default CustomTextareaAutosize;
